/// <reference path="" />

(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.vm === "undefined") {
        jQuery.extend(sm.portal, { vm: {} });
    }
    if (typeof sm.portal.vm.placementTest === "undefined") {
        jQuery.extend(sm.portal.vm, { placementTest: {} });
    }

    /**************************************/
    // GRE View Model
    // Holds the GRE Scores
    /**************************************/
    function GREViewModel(options) {
        var defaults = {
            PlacementTestType: 'GRE',
            ID: 0,
            TestDate: null,
            Verbal: 0,
            Quantitative: 0,
            AnalyticalWriting: 0,
            Mode: 'Add',
            Index: 0
        };
        var settings = jQuery.extend({}, defaults, options);

        // Self-Identification
        var self = this;

        this.PlacementTestType = ko.observable(settings.PlacementTestType);
        this.Index = ko.observable(settings.Index);
        this.ID = ko.observable(settings.ID);
        this.TestDate = ko.validatedObservable(settings.TestDate);
        this.Verbal = ko.validatedObservable(settings.Verbal);
        this.Quantitative = ko.validatedObservable(settings.Quantitative);
        this.AnalyticalWriting = ko.validatedObservable(settings.AnalyticalWriting);

        // add/edit mode
        this.Mode = ko.observable(settings.Mode);

        /*** TEST PROPERTIES ***/
        this.Touched = ko.observable(false);
        this.Clone = function () {
            return new sm.portal.vm.placementTest.GREViewModel({
                ID: this.ID(),
                TestDate: this.TestDate(),
                Quantitative: this.Quantitative(),
                Verbal: this.Verbal(),
                AnalyticalWriting: this.AnalyticalWriting(),
                Mode: this.Mode(),
                Index: this.Index()
            });
        };
        this.Copy = function (data) {
            return new sm.portal.vm.placementTest.GREViewModel({
                ID: data.ID(),
                TestDate: data.TestDate(),
                Quantitative: data.Quantitative(),
                Verbal: data.Verbal(),
                AnalyticalWriting: data.AnalyticalWriting(),
                Mode: data.Mode(),
                Index: data.Index()
            });
        };
        this.Clear = function () {
            this.ID('');
            this.TestDate('');
            this.Quantitative('');
            this.Verbal('');
            this.AnalyticalWriting('');
            this.Index(0);
            this.Mode('Add');
        }    
        /*** TEST PROPERTIES ***/

        /***  COMPUTED PROPERTIES ***/
        this.ScoreSummary = ko.computed(function () {
            return sm.portal.utility.getResourceValue('Quantitative') + ': ' + this.Quantitative() +
                ', ' + sm.portal.utility.getResourceValue('Verbal') + ': ' + this.Verbal() +
                ', ' + sm.portal.utility.getResourceValue('AnalyticalWriting') + ': ' + this.AnalyticalWriting();
        }, this);
        this.ItemAsString = ko.computed(function () {
            var str = this.TestDate() + this.Verbal() + this.Quantitative() + this.AnalyticalWriting();
            return str;
        }, this);
        this.AnythingPopulated = ko.computed(function () {

            if (!sm.portal.utility.isNullOrEmpty(self.TestDate())) return true;
            if (!sm.portal.utility.isNullOrEmpty(self.Verbal())) return true;
            if (!sm.portal.utility.isNullOrEmpty(self.Quantitative())) return true;
            if (!sm.portal.utility.isNullOrEmpty(self.AnalyticalWriting())) return true;

            return false;

        }, this);
        this.Completed = ko.computed(function () {

            var isCompleted = this.AnythingPopulated() || this.Touched();
            return isCompleted;

        }, this);
        /***  COMPUTED PROPERTIES ***/

        /*** SECTION PROPERTIES ***/
        this.ExtractATO = function () {
            // [EXTEND] New fields added to view model need to be updated here
            return new smapi.admissions.GREGeneralModel({
                ID: self.ID(),
                TestDate: self.TestDate(),
                Verbal: self.Verbal(),
                Quantitative: self.Quantitative(),
                Writing: self.AnalyticalWriting(),
            });
        };
        /*** SECTION PROPERTIES ***/

        /*** VALIDATION METHODS ***/
        this.TestDate.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            smLocalDate: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeADate_Key)
            }
        });
        this.Verbal.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterThan0_Key), '0')
            },
            max: {
                params: 170,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessThan0_Key), '170')
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.Quantitative.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterThan0_Key), '0')
            },
            max: {
                params: 170,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessThan0_Key), '170')
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });
        this.AnalyticalWriting.extend({
            required: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_FieldRequired_Key)
            },
            min: {
                params: 0,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_GreaterThan0_Key), '0')
            },
            max: {
                params: 6,
                message: sm.portal.utility.formatString(sm.portal.utility.getResourceValue(smapi.constant.validate_LessThan0_Key), '6')
            },
            number: {
                params: true,
                message: sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key)
            }
        });

        // Set Model Grouping for validation
        this.ModelErrors = ko.validation.group(this);
        // Check if Model is valid 
        // (will NOT validate attached models, unless we
        //  init that in ui.js - currently it has performance problems)
        this.IsVMValid = function () {
            if (this.ModelErrors().length == 0) {
                return true;
            } else {
                return false;
            }
        };
        this.Completed = ko.computed(function () {
            var isCompleted = this.IsVMValid() && (this.AnythingPopulated() || this.Touched());
            return isCompleted;
        }, this);
        /*** VALIDATION METHODS ***/

        return self;
    }

    jQuery.extend(true, sm.portal.vm.placementTest, {
        GREViewModel: GREViewModel,
    });

})(jQuery);